// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1TB_T","col":"styles_col__aJOQ7"};